import { useTranslation } from 'react-i18next';
import type { AuditLog } from '@bliks-io/contracts';

export function ChangesDetail({ log }: { log: AuditLog }) {
  const { t } = useTranslation();
  if (log.changes && log.changes.length > 0) {
    return (
      <div className="p-4">
        <h4 className="font-semibold mb-2">{t('auditLogs.fieldChanges')}</h4>
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b">
              <th className="text-left p-1">{t('auditLogs.field')}</th>
              <th className="text-left p-1">{t('auditLogs.from')}</th>
              <th className="text-left p-1">{t('auditLogs.to')}</th>
            </tr>
          </thead>
          <tbody>
            {log.changes.map((change, i) => (
              <tr key={i} className="border-b">
                <td className="p-1 font-mono text-xs">{change.field}</td>
                <td className="p-1 text-xs text-muted-foreground">{JSON.stringify(change.from)}</td>
                <td className="p-1 text-xs">{JSON.stringify(change.to)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  if (log.batchInfo) {
    return (
      <div className="p-4">
        <h4 className="font-semibold mb-2">{t('auditLogs.batchInfo')}</h4>
        <dl className="grid grid-cols-2 gap-2 text-sm">
          <dt className="text-muted-foreground">{t('auditLogs.batchFilter')}</dt>
          <dd className="font-mono text-xs">{JSON.stringify(log.batchInfo.filter)}</dd>
          {log.batchInfo.update && (
            <>
              <dt className="text-muted-foreground">{t('auditLogs.batchUpdate')}</dt>
              <dd className="font-mono text-xs">{JSON.stringify(log.batchInfo.update)}</dd>
            </>
          )}
          <dt className="text-muted-foreground">{t('auditLogs.batchMatched')}</dt>
          <dd>{log.batchInfo.matchedCount}</dd>
          <dt className="text-muted-foreground">{t('auditLogs.batchModified')}</dt>
          <dd>{log.batchInfo.modifiedCount}</dd>
        </dl>
      </div>
    );
  }

  if (log.snapshot) {
    return (
      <div className="p-4">
        <h4 className="font-semibold mb-2">{t('auditLogs.snapshot')}</h4>
        <pre className="text-xs bg-muted p-2 rounded overflow-auto max-h-64">
          {JSON.stringify(log.snapshot, null, 2)}
        </pre>
      </div>
    );
  }

  return <div className="p-4 text-sm text-muted-foreground">{t('auditLogs.noDetails')}</div>;
}
